/** Canonical display name; must exist as an active row in ``authorization_business_units`` (GET /business-units). */
export const DEFAULT_BUSINESS_UNIT_NAME = "On Call" as const;
